import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";

export function receberFiltro() {
  const route = useRoute();

  const filtros = ref({});
  const filtrar = ref(false);

  const verificarFiltroRota = () => {
    if (sessionStorage.getItem(route.path) == undefined) {
      filtrar.value = true;
      return;
    }
    filtros.value = JSON.parse(sessionStorage.getItem(route.path));
    filtrar.value = true;
  };

  onMounted(() => {
    verificarFiltroRota();
  });

  return { verificarFiltroRota, filtros, filtrar };
}
